import React, { useState, useEffect } from 'react';
import { Text, View, ScrollView, Image } from 'react-native';
import { useTheme } from '@themeProvider';
import { useLanguage } from '@languageProvider';
import { Spacing, Typography, Mixins, Commons } from '@styles';
import { Order } from '@datamodel';
import { OrderCard } from '@molecules';
import { Button } from '@atoms';
import service, { Orders } from '@services';

const styles = Commons.styles;

export const ProfileDrawer = ({ style, profile, eventId, placeId, isAuth, slug, menu, setCartFromOrder, ...props }) => {
    const [orderList, setOrderList] = useState({
        redeemables: {},
        completed: {}
    });

    const { translate } = useLanguage();
    const { useColor } = useTheme();

    const [title, body, line] = useColor(['title', 'body', 'line']);

    const oauthLogin = async () => {
        const state = {
            event: eventId,
            place: placeId
        }
        service.createOAuth(btoa(JSON.stringify(state)));
    }

    const oauthLogout = async () => {
        service.deleteOAuth();
    }

    useEffect(() => {
        if (isAuth) {
            (async () => {
                try {
                    const lastOrders = await Orders.list();
                    setOrderList(Order.collectionSplitByRedeemable(lastOrders.orders));
                } catch (error) {
                    console.error(error);
                }
            })();
        }
    }, [isAuth]);

    return <View {...props} style={[{ padding: Spacing.M, paddingBottom: 0 }, style]}>
        {isAuth ?
            <View style={{ flexGrow: 1, maxWidth: '100%', maxHeight: '100%' }}>
                <Text style={[Typography.SUBTITLE, { color: body, flexShrink: 1, textAlign: 'center', marginBottom: Spacing.S }]}>
                    {translate('welcomeBack')}
                </Text>
                <View style={[Mixins.HORIZONTAL, { alignItems: 'center' }]}>
                    <Image source={{ uri: profile.pic }} style={styles.profilePic} />
                    <View style={{ flex: 1, marginLeft: Spacing.XS, }}>
                        <Text numberOfLines={2} ellipsizeMode="head" style={[Typography.TITLE, { color: title, flexShrink: 1 }]}>{profile.name}</Text>
                        <Text numberOfLines={1} ellipsizeMode="head" style={[Typography.CAPTION, { color: body, flexShrink: 1 }]}>{profile.email}</Text>
                    </View>
                </View>

                <Button onPress={oauthLogout} type="secondary" title={translate('logOut')} size="condensed" color="destructive" style={{ marginTop: Spacing.M }} />

                <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ paddingBottom: Spacing.M }}>
                    {Object.keys(orderList.redeemables).length > 0 &&
                        <>
                            <Text style={[Typography.OVERLINE, { color: body, marginTop: Spacing.M }]}>{translate('activeOrders')}</Text>
                            <View>
                                {Object.keys(orderList.redeemables).sort((o1, o2) => {
                                    return orderList.redeemables[o2].succeededAt - orderList.redeemables[o1].succeededAt
                                }).map(orderId => {
                                    const order = orderList.redeemables[orderId];
                                    const orderUrl = `${service.api_prefix}tripay/${slug}/orders/${orderId}/confirmation/`;
                                    const repeatable = Order.isRepeatable(order, menu);
                                    return <OrderCard
                                        key={orderId}
                                        repeat={repeatable && (() => setCartFromOrder(order))}
                                        {...{ order, orderUrl }}
                                        style={{ borderBottomWidth: 1, borderColor: line }} />
                                })}
                            </View>
                        </>
                    }

                    {Object.keys(orderList.completed).length > 0 &&
                        <>
                            <Text style={[Typography.OVERLINE, { color: body, marginTop: Spacing.XL }]}>{translate('pastOrders')}</Text>
                            <View>
                                {Object.keys(orderList.completed).sort((o1, o2) => {
                                    return orderList.completed[o2].succeededAt - orderList.completed[o1].succeededAt
                                }).map(orderId => {
                                    const order = orderList.completed[orderId];
                                    const orderUrl = `${service.api_prefix}tripay/${slug}/orders/${orderId}/confirmation/`;
                                    const repeatable = Order.isRepeatable(order, menu);

                                    return <OrderCard
                                        key={orderId}
                                        repeat={repeatable && (() => setCartFromOrder(order))}
                                        {...{ order, orderUrl }}
                                        style={{ borderBottomWidth: 1, borderColor: line }} />
                                })}
                            </View>
                        </>
                    }
                </ScrollView>

            </View>
            : <View style={{ flexGrow: 1, justifyContent: 'center', maxWidth: '100%' }}>
                <Text style={[Typography.BODY, { color: body, flexShrink: 1 }]}>{translate('profileDrawerSignInCopy')}</Text>
                <Button onPress={oauthLogin} title={translate('signIn')} size="condensed" style={{ marginTop: Spacing.M }} />
            </View>
        }
    </View>
}
